module.exports = __webpack_public_path__ + "img/public/SiteIcons/question.svg?1f2b92c8";